export function getFirstAndLastDate(year, month) {
  const firstDate = new Date(Date.UTC(year, month) - 24 * 60 * 60 * 1000).toISOString();
  const lastDate = new Date(Date.UTC(year, month + 1) - 24 * 60 * 60 * 1000).toISOString();
  return { firstDate, lastDate };
}

export function getFirstAndLastDateOfYear(year, month) {
  let firstDate;
  let lastDate;

  if (typeof year !== 'number') {
    throw new Error('Year is required and must be a number');
  }

  // Nếu không truyền month → lấy ngày đầu và cuối năm
  if (month === undefined) {
    firstDate = new Date(Date.UTC(year, 0) - 24 * 60 * 60 * 1000);
    lastDate = new Date(Date.UTC(year + 1, 0) - 24 * 60 * 60 * 1000);
  } else {
    // Nếu truyền month → lấy ngày đầu tháng và cuối năm
    firstDate = new Date(Date.UTC(year, month) - 24 * 60 * 60 * 1000);
    lastDate = new Date(Date.UTC(year + 1, 0) - 24 * 60 * 60 * 1000);
  }

  return {
    firstDate: firstDate.toISOString(),
    lastDate: lastDate.toISOString(),
  };
}

